import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=a01b5bb0&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "../pc.css?vue&type=style&index=0&id=a01b5bb0&scoped=true&lang=css&"
import style1 from "../phone.css?vue&type=style&index=1&id=a01b5bb0&scoped=true&lang=css&"
import style2 from "./contact.vue?vue&type=style&index=2&id=a01b5bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01b5bb0",
  null
  
)

export default component.exports